import {Component, ChangeDetectorRef, ViewChildren, QueryList} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, Select, ViewController} from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { ReportSearchUnitmodelPage} from "../report-search-unitmodel/report-search-unitmodel";
import { DataService } from "../../services/data.service";
import { ReportSelectUnitPage } from "../report-select-unit/report-select-unit";
import { InfoModalPage } from "../info-modal/info-modal";
import { ReportSelectUnitbrandPage } from "../report-select-unitbrand/report-select-unitbrand";
import { Camera } from "@ionic-native/camera";
import {ApiService} from "../../services/api.service";
import {FileService} from "../../services/file.service";
import {ViewPhotoPage} from "../view-photo/view-photo";

@Component({
  selector: 'page-report-edit-unit',
  templateUrl: 'report-edit-unit.html',
})
export class ReportEditUnitPage {

  @ViewChildren(Select) ionSelects: QueryList<Select>;

  units = [];
  parent: ReportSelectUnitPage;
  data: any;
  unit: any;
  photos = [];
  files = [];
  unitBrands = [];
  unitForm: FormGroup;
  allowWarranty = false;
  saving = false;
  unitType = 1;

  children = [];
  childForms: Array<FormGroup> = [];

  unitTypeInfoHtml = '<table><tr><td colspan="4"><strong>VST 1 voorheen A</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Indirect</td></tr><tr><td colspan="4"><strong>VST 2 voorheen B</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 3 voorheen C</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 4 voorheen C 4c</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td colspan="4"><strong>VST 5 voorheen D</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 6 voorheen D</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 7 voorheen E (X)</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr></table>';

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.unitForm.controls['time_installation'].setValue(null);
      }
    }]
  };

  datePickerOptionsExhaustCheck: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.unitForm.controls['time_next_exhaust_check'].setValue(null);
      }
    }]
  };

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public formBuilder: FormBuilder,
      public modalCtrl: ModalController,
      public viewCtrl: ViewController,
      public changeDetector: ChangeDetectorRef,
      public barcodeScanner: BarcodeScanner,
      public dataService: DataService,
      public camera: Camera,
      public fileService: FileService,
      public alertCtrl: AlertController,
      public apiService: ApiService
  ) {
    this.saving = false;
    this.parent = this.navParams.get('parent');
    this.unit = this.navParams.get('unit');
    this.unitType = (this.unit.unit_model_unit_type ? parseInt(this.unit.unit_model_unit_type) : 1);
    if (this.unit.photos) this.photos = this.unit.photos;
    if (this.unit.files) this.files = this.unit.files;
    if (this.unit.children) this.children = this.unit.children;

    /*
    this.photos = [
      {
        file_id: 1,
        src: 'https://via.placeholder.com/400x300'
      }
    ];
    */

    // Set allowWarranty bij '1e inbedrijfstelling (1)' en 'Aanmelden nieuw toestel (5)'
    if (this.parent.data.workorder_type == '1' || this.parent.data.workorder_type == '5') {
      this.allowWarranty = true;
    }
    /* Fix unit_brand_id, unit_model and unit_version */
    if (!this.unit.unit_brand_id && this.unit.unit_version.unit_model && this.unit.unit_version.unit_model.unit_brand_id) this.unit.unit_brand_id = this.unit.unit_version.unit_model.unit_brand_id;
    if (!this.unit.unit_model && this.unit.unit_version.unit_model && this.unit.unit_version.unit_model.title) this.unit.unit_model = this.unit.unit_version.unit_model.title;
    if (this.unit.unit_version && this.unit.unit_version.title) this.unit.unit_version = this.unit.unit_version.title;
    /**/

    // Init
    this.initForm();
    this.initChildren();
  }

  initForm(){
    let currentYear = new Date().getFullYear();
    // CV
    if(this.unitType === 1) {
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: [''],
        new_serial_nr: [''],
        passport_nr: [''],
        new_passport_nr: [''],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        nominal_power: ['', Validators.required],
        openings: ['', Validators.required],
        fuel_type: [(this.unit.fuel_type ? this.unit.fuel_type : 'Aardgas')],
        cascade: [(this.unit.cascade ? this.unit.cascade : 'Nee')],
        unit_type: [''],
        exhaust_type: ['', Validators.required],
        exhaust_replaced: [''],
        exhaust_location: [''],
        service_interval: [(this.unit.service_interval ? this.unit.service_interval : '24'), Validators.required],
        contract_nr: [''],
        plan_code: [(this.unit.plan_code ? this.unit.plan_code : '4')],
        time_installation: [''],
        time_next_exhaust_check: [''],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        co_detector: [''],
        co_detector_year: ['', Validators.compose([Validators.min(1900), Validators.max(2099)])],
        burner_brand: [''],
        burner_type: [''],
        burner_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        burner_serial_nr: [''],
        burner_flow_rate_unit: [''],
        burner_flow_rate_value: [''],
        sprinkler_brand: [''],
        sprinkler_type: [''],
        sprinkler_flow_rate_unit: [''],
        sprinkler_flow_rate_value: [''],
        sprinkler_angle: [''],
      });
      this.unitForm.patchValue(this.unit);
    }
    // Ventilatie
    if(this.unitType === 2){
      this.unitForm = this.formBuilder.group({
        unit_brand: [(this.unit.unit_brand ? this.unit.unit_brand : ''), Validators.required],
        unit_brand_id: [(this.unit.unit_brand_id ? this.unit.unit_brand_id : '')],
        unit_model: [(this.unit.unit_model ? this.unit.unit_model : ''), Validators.required],
        unit_model_id: [(this.unit.unit_model_id ? this.unit.unit_model_id : '')],
        unit_version: [(this.unit.unit_version ? this.unit.unit_version : '')],
        unit_version_id: [(this.unit.unit_version_id ? this.unit.unit_version_id : '')],
        serial_nr: [(this.unit.serial_nr ? this.unit.serial_nr : '')],
        new_serial_nr: [(this.unit.new_serial_nr ? this.unit.new_serial_nr : '')],
        passport_nr: [(this.unit.passport_nr ? this.unit.passport_nr : '')],
        new_passport_nr: [(this.unit.new_passport_nr ? this.unit.new_passport_nr : '')],
        unit_nr: [(this.unit.unit_nr ? this.unit.unit_nr : '')],
        year: [(this.unit.year ? this.unit.year : ''), Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        unit_type: [(this.unit.unit_type ? this.unit.unit_type : '')],
        capacity: (this.unit.capacity ? this.unit.capacity : ''),
        filter_type: (this.unit.filter_type ? this.unit.filter_type : ''),
        password: (this.unit.password ? this.unit.password : ''),
        ventilation_setting0: (this.unit.ventilation_setting0 ? this.unit.ventilation_setting0 : ''),
        ventilation_setting1: (this.unit.ventilation_setting1 ? this.unit.ventilation_setting1 : ''),
        ventilation_setting2: (this.unit.ventilation_setting2 ? this.unit.ventilation_setting2 : ''),
        ventilation_setting3: (this.unit.ventilation_setting3 ? this.unit.ventilation_setting3 : ''),
        ventilation_setting4: (this.unit.ventilation_setting4 ? this.unit.ventilation_setting4 : ''),
        ventilation_setting5: (this.unit.ventilation_setting5 ? this.unit.ventilation_setting5 : ''),
        control_type: (this.unit.control_type ? this.unit.control_type : ''),
        co2_detector: [(this.unit.co2_detector ? this.unit.co2_detector : '')],
        hygro_detector: [(this.unit.hygro_detector ? this.unit.hygro_detector : '')],
        service_interval: [(this.unit.service_interval ? this.unit.service_interval : ''), Validators.required],
        contract_nr: [(this.unit.contract_nr ? this.unit.contract_nr : '')],
        plan_code: [(this.unit.plan_code ? this.unit.plan_code : '4')],
        time_installation: [(this.unit.time_installation ? this.unit.time_installation : '')],
        warranty: [(this.unit.warranty ? this.unit.warranty : '')],
        extended_warranty: [(this.unit.extended_warranty ? this.unit.extended_warranty : '')],
        extended_warranty_duration: [(this.unit.extended_warranty_duration ? this.unit.extended_warranty_duration : '')]
      });
    }
    // Waterontharder
    if(this.unitType === 3){
      this.unitForm = this.formBuilder.group({
        unit_brand: [(this.unit.unit_brand ? this.unit.unit_brand : ''), Validators.required],
        unit_brand_id: [(this.unit.unit_brand_id ? this.unit.unit_brand_id : '')],
        unit_model: [(this.unit.unit_model ? this.unit.unit_model : ''), Validators.required],
        unit_model_id: [(this.unit.unit_model_id ? this.unit.unit_model_id : '')],
        unit_version: [(this.unit.unit_version ? this.unit.unit_version : '')],
        unit_version_id: [(this.unit.unit_version_id ? this.unit.unit_version_id : '')],
        serial_nr: [(this.unit.serial_nr ? this.unit.serial_nr : '')],
        new_serial_nr: [(this.unit.new_serial_nr ? this.unit.new_serial_nr : '')],
        passport_nr: [(this.unit.passport_nr ? this.unit.passport_nr : '')],
        new_passport_nr: [(this.unit.new_passport_nr ? this.unit.new_passport_nr : '')],
        unit_nr: [(this.unit.unit_nr ? this.unit.unit_nr : '')],
        maximum_capacity: [(this.unit.maximum_capacity ? this.unit.maximum_capacity : '')],
        daily_capacity: [(this.unit.daily_capacity ? this.unit.daily_capacity : '')],
        unit_location: [(this.unit.unit_location ? this.unit.unit_location : '')],
        resin_content: [(this.unit.resin_content ? this.unit.resin_content : '')],
        salt_usage: [(this.unit.salt_usage ? this.unit.salt_usage : '')],
        unit_usage: [(this.unit.unit_usage ? this.unit.unit_usage : '')],
        not_softened: [(this.unit.not_softened ? this.unit.not_softened : '')],
        year: [(this.unit.year ? this.unit.year : ''), Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        backwash: [(this.unit.backwash ? this.unit.backwash : '')],
        sucking: [(this.unit.sucking ? this.unit.sucking : '')],
        flushing: [(this.unit.flushing ? this.unit.flushing : '')],
        filling1: [(this.unit.filling1 ? this.unit.filling1 : '')],
        filling2: [(this.unit.filling2 ? this.unit.filling2 : '')],
        set_flushing_time: [(this.unit.set_flushing_time ? this.unit.set_flushing_time : '')],
        valve_voltage: [(this.unit.valve_voltage ? this.unit.valve_voltage : '')],
        service_interval: [(this.unit.service_interval ? this.unit.service_interval : '24'), Validators.required],
        regeneration_time1: [(this.unit.regeneration_time1 ? this.unit.regeneration_time1 : '')],
        regeneration_time2: [(this.unit.regeneration_time2 ? this.unit.regeneration_time2 : '')],
        regeneration_time3: [(this.unit.regeneration_time3 ? this.unit.regeneration_time3 : '')],
        regeneration_time4: [(this.unit.regeneration_time4 ? this.unit.regeneration_time4 : '')],
        regeneration_time5: [(this.unit.regeneration_time5 ? this.unit.regeneration_time5 : '')],
        software_version: [(this.unit.software_version ? this.unit.software_version : '')],
        regulation_type: [(this.unit.regulation_type ? this.unit.regulation_type : '')],
        password: [(this.unit.password ? this.unit.password : '')],
        operation_type: [(this.unit.operation_type ? this.unit.operation_type : '')],
        contract_nr: [(this.unit.contract_nr ? this.unit.contract_nr : '')],
        plan_code: [(this.unit.plan_code ? this.unit.plan_code : '4')],
        time_installation: [(this.unit.time_installation ? this.unit.time_installation : '')],
        warranty: [(this.unit.warranty ? this.unit.warranty : '')],
        extended_warranty: [(this.unit.extended_warranty ? this.unit.extended_warranty : '')],
        extended_warranty_duration: [(this.unit.extended_warranty_duration ? this.unit.extended_warranty_duration : '')]
      });
    }
    // Hijstoestel
    if(this.unitType === 4){
      this.unitForm = this.formBuilder.group({
        unit_brand: [(this.unit.unit_brand ? this.unit.unit_brand : ''), Validators.required],
        unit_brand_id: [(this.unit.unit_brand_id ? this.unit.unit_brand_id : '')],
        unit_model: [(this.unit.unit_model ? this.unit.unit_model : ''), Validators.required],
        unit_model_id: [(this.unit.unit_model_id ? this.unit.unit_model_id : '')],
        unit_version: [(this.unit.unit_version ? this.unit.unit_version : '')],
        unit_version_id: [(this.unit.unit_version_id ? this.unit.unit_version_id : '')],
        serial_nr: [(this.unit.serial_nr ? this.unit.serial_nr : '')],
        new_serial_nr: [(this.unit.new_serial_nr ? this.unit.new_serial_nr : '')],
        passport_nr: [(this.unit.passport_nr ? this.unit.passport_nr : '')],
        new_passport_nr: [(this.unit.new_passport_nr ? this.unit.new_passport_nr : '')],
        unit_nr: [(this.unit.unit_nr ? this.unit.unit_nr : '')],
        unit_location: [(this.unit.unit_location ? this.unit.unit_location : '')],
        certificate_nr: [(this.unit.certificate_nr ? this.unit.certificate_nr : '')],
        nominal_load: [(this.unit.nominal_load ? this.unit.nominal_load : '')],
        year: [(this.unit.year ? this.unit.year : ''), Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        service_interval: [(this.unit.service_interval ? this.unit.service_interval : ''), Validators.required],
        contract_nr: [(this.unit.contract_nr ? this.unit.contract_nr : '')],
        plan_code: [(this.unit.plan_code ? this.unit.plan_code : '4')],
        time_installation: [(this.unit.time_installation ? this.unit.time_installation : '')],
        warranty: [(this.unit.warranty ? this.unit.warranty : '')],
        extended_warranty: [(this.unit.extended_warranty ? this.unit.extended_warranty : '')],
        extended_warranty_duration: [(this.unit.extended_warranty_duration ? this.unit.extended_warranty_duration : '')]
      });
    }
    // Airco
    if(this.unitType === 5) {
      this.unitForm = this.formBuilder.group({
        unit_brand: [(this.unit.unit_brand ? this.unit.unit_brand : ''), Validators.required],
        unit_brand_id: [(this.unit.unit_brand_id ? this.unit.unit_brand_id : '')],
        unit_model: [(this.unit.unit_model ? this.unit.unit_model : ''), Validators.required],
        unit_model_id: [(this.unit.unit_model_id ? this.unit.unit_model_id : '')],
        unit_version: [(this.unit.unit_version ? this.unit.unit_version : '')],
        unit_version_id: [(this.unit.unit_version_id ? this.unit.unit_version_id : '')],
        serial_nr: [(this.unit.serial_nr ? this.unit.serial_nr : '')],
        new_serial_nr: [(this.unit.new_serial_nr ? this.unit.new_serial_nr : '')],
        passport_nr: [(this.unit.passport_nr ? this.unit.passport_nr : '')],
        new_passport_nr: [(this.unit.new_passport_nr ? this.unit.new_passport_nr : '')],
        unit_nr: [(this.unit.unit_nr ? this.unit.unit_nr : '')],
        year: [(this.unit.year ? this.unit.year : ''), Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        outside_unit_location: [(this.unit.outside_unit_location ? this.unit.outside_unit_location : '')],
        coolant_type: [(this.unit.coolant_type ? this.unit.coolant_type : '')],
        power: [(this.unit.power ? this.unit.power : '')],
        nominal_coolant_level: [(this.unit.nominal_coolant_level ? this.unit.nominal_coolant_level : '')],
        additional_coolant_amount: [(this.unit.additional_coolant_amount ? this.unit.additional_coolant_amount : '')],
        total_coolant_amount: [(this.unit.total_coolant_amount ? this.unit.total_coolant_amount : '')],
        regulation_type: [(this.unit.regulation_type ? this.unit.regulation_type : '')],
        service_interval: [(this.unit.service_interval ? this.unit.service_interval : ''), Validators.required],
        time_installation: [(this.unit.time_installation ? this.unit.time_installation : '')],
        password: [(this.unit.password ? this.unit.password : '')],
        contract_nr: [(this.unit.contract_nr ? this.unit.contract_nr : '')],
        plan_code: [(this.unit.plan_code ? this.unit.plan_code : '4')],
        warranty: [(this.unit.warranty ? this.unit.warranty : '')],
        extended_warranty: [(this.unit.extended_warranty ? this.unit.extended_warranty : '')],
        extended_warranty_duration: [(this.unit.extended_warranty_duration ? this.unit.extended_warranty_duration : '')]
      });
    }
    // Gasleiding
    if(this.unitType === 7) {
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: [''],
        new_serial_nr: [''],
        passport_nr: [''],
        new_passport_nr: [''],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
        location_gas_meter: [''],
        part_checked: [''],
        piping_not_visible: [''],
        materials_used: [''],
        piping_fitted: [''],
        piping_covered: [''],
        piping_protected: [''],
        contract_nr: [''],
        plan_code: ['4'],
      });
      this.unitForm.patchValue(this.unit);
    }
    // Algemeen
    if(this.unitType === 8) {
      this.unitForm = this.formBuilder.group({
        general_unit_type: ['', Validators.required],
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: [''],
        new_serial_nr: [''],
        passport_nr: [''],
        new_passport_nr: [''],
        unit_nr: [''],
        contract_nr: [''],
        plan_code: [''],
        notes: [''],
      });
      this.unitForm.patchValue(this.unit);
    }
    // Gas- of sfeerhaard
    if(this.unitType === 9) {
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        nominal_power: ['', Validators.required],
        openings: ['Ja', Validators.required],
        fuel_type: ['Aardgas'],
        exhaust_location: [''],
        service_interval: ['', Validators.required],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        co_detector: [''],
        co_detector_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        new_serial_nr: [''],
        new_passport_nr: [''],
        burner_brand: [''],
        burner_type: [''],
        burner_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        burner_serial_nr: [''],
        burner_flow_rate_unit: [''],
        burner_flow_rate_value: [''],
        sprinkler_brand: [''],
        sprinkler_type: [''],
        sprinkler_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        sprinkler_flow_rate_unit: [''],
        sprinkler_flow_rate_value: [''],
        sprinkler_angle: [''],
      });
      this.unitForm.patchValue(this.unit);
    }
    this.dataService.getUnitBrands().then((data) => {
      // @ts-ignore
      this.unitBrands = data;
    }).catch((error) => {
      console.error(error);
    });
  }

  initChildren(){
    // Init childForms
    this.childForms = [];
    for(let child of this.children) {
      let form = null;
      switch(child.unit_model_unit_type) {
        case 6:
          // Volumestromen ventilatietoevoer (type = 201)
          form = this.formBuilder.group({
            room: [''],
            floor: [''],
            unit_brand: ['', Validators.required],
            unit_brand_id: [''],
            unit_model: ['', Validators.required],
            unit_model_id: [''],
            unit_version: [''],
            unit_version_id: [''],
            serial_nr: [''],
            new_serial_nr: [''],
            passport_nr: [''],
            new_passport_nr: [''],
            unit_nr: [''],
            year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(2099)])],
            inside_unit_location: [''],
            notes: [''],
            service_interval: ['', Validators.required],
            time_installation: [''],
            plan_code: ['4'],
          });
          break;
      }
      if(form) {
        form.patchValue(child);
        this.childForms.push(form);
      }
    }
  }

  searchUnitmodel(){
    this.modalCtrl.create(ReportSearchUnitmodelPage, {
      unitType: this.unitType,
      form: this.unitForm
    }).present();
  }

  selectBrand(){
    this.modalCtrl.create(ReportSelectUnitbrandPage, {
      form: this.unitForm
    }).present();
  }

  scanBarcode(field, form?: FormGroup){
    if(!form){
      form = this.unitForm;
    }
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if((field == 'passport_nr' || field == 'new_passport_nr') && barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        if((field == 'passport_nr' || field == 'new_passport_nr') && this.apiService.hasActiveSubscription('EDUCATIE') && barcode.substr(0, 2) != 'TE'){
          this.alertCtrl.create({
            title: 'TE nummer',
            message: 'U heeft een educatie licentie. Hiermee kunt u alleen stickers gebruiken die een TE nummer hebben.',
            buttons: ['OK']
          }).present();
        } else {
          form.get(field).setValue(barcode);
          if(field == 'new_passport_nr'){
            this.onNewPassportNrChange();
            // Waarschuwing TE sticker bij account zonder EDUCATIE licentie
            if(!this.apiService.hasActiveSubscription('EDUCATIE') && barcode.substr(0, 2) == 'TE') {
              this.alertCtrl.create({
                title: 'TE nummer',
                message: 'U heeft een TE sticker gescand, terwijl u geen educatie licentie heeft. Neem contact op met Maintenanz om de juiste stickers te bestellen.',
                buttons: ['OK']
              }).present();
            }
          }
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  onNewPassportNrChange(){
    let barcode = this.unitForm.get('new_passport_nr').value;
    if(barcode){
      this.apiService.checkQr(barcode).then((data) => {
        if(data > 0){
          this.alertCtrl.create({
            title: 'Waarschuwing',
            message: 'Dit installatiepas nummer is al in gebruik bij een andere installatie.',
            buttons: ['OK']
          }).present();
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  onUnitTypeSelect(value){
    // Als unit_type == 'Atmosferische ketel', exhaust_type instellen op 'Open toestel type B'
    if (value == 'Atmosferische ketel') {
      this.unitForm.get('exhaust_type').setValue('Open toestel type B');
    }
  }

  onTimeInstallationChange(){
    // time_next_exhaust_check invullen met time_installation + 15 jaar
    let value = this.unitForm.get('time_installation').value;
    let year = parseInt(value.substr(0, 4));
    let time_next_exhaust_check = (year + 15) + value.substr(4, 6);
    this.unitForm.get('time_next_exhaust_check').setValue(time_next_exhaust_check);
  }

  addPhoto(){
    this.alertCtrl.create({
      title: 'Foto toevoegen',
      cssClass: 'alert-not-bold',
      buttons: [
        {
          text: 'Nieuwe foto maken',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Kies foto uit fotoalbum',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        }
      ]
    }).present();
  }

  getPicture(sourceType){
    this.camera.getPicture({
      quality: 60,
      targetWidth: 1200,
      targetHeight: 1200,
      correctOrientation: true,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }).then((imageData) => {
      let src = 'data:image/jpeg;base64,' + imageData;
      if(this.unitType == 1){
        this.alertCtrl.create({
          title: 'Foto',
          inputs: [
            {
              name: 'title',
              type: 'radio',
              label: 'Met kap',
              value: 'Met kap'
            },
            {
              name: 'title',
              type: 'radio',
              label: 'Zonder kap',
              value: 'Zonder kap'
            }
          ],
          buttons: [
            {
              text: 'Annuleren',
              role: 'cancel'
            },
            {
              text: 'OK',
              handler: (data) => {
                this.photos.push({
                  title: data,
                  src: src
                });
                this.uploadPhotos();
              }
            }
          ]
        }).present();
      } else {
        this.photos.push({
          title: '',
          src: src
        });
      }
    }, (err) => {
      this.changeDetector.detectChanges();
    });
  }

  addFile(){
    this.fileService.getFile().then((file) => {
      this.files.push(file);
      this.uploadFiles();
    }).catch((error) => {
      this.changeDetector.detectChanges();
      if(error == -1){
        this.alertCtrl.create({
          title: 'Bestand te groot',
          message: 'Dit bestand is te groot. Het bestand mag maximaal ' + this.fileService.maxFileSizeMegaBytes + 'MB groot zijn',
          buttons: ['OK']
        }).present();
      }
    });
  }

  viewPhoto(photo, index){
    this.modalCtrl.create(ViewPhotoPage, {
      photo: photo,
      photos: this.photos,
      index: index
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  getPhotosCount(){
    let photosCount = 0;
    for (let p of this.photos) {
      if (!p._deleted) {
        photosCount++;
      }
    }
    return photosCount;
  }

  getFilesCount(){
    let filesCount = 0;
    for (let p of this.files) {
      if (!p._deleted) {
        filesCount++;
      }
    }
    return filesCount;
  }

  removeFile(index, filename){
    this.alertCtrl.create({
      title: 'Bestand verwijderen',
      message: 'Wilt u bestand \'' + filename + '\' verwijderen?',
      buttons: [
        {
          text: 'Nee',
          role: 'cancel'
        },{
          text: 'Ja',
          handler: () => {
            // @ts-ignore
            if(this.files[index] && this.files[index].file_id > 0){
              // @ts-ignore
              this.files[index]._deleted = true;
              this.files[index].src = '';
            } else {
              this.files.splice(index, 1);
            }
          }
        }
      ]
    }).present();
  }

  saveFormsToChildren(){
    if(this.children.length === 0){
      return;
    }
    let i = 0;
    for(let child of this.children){
      let values = this.childForms[i].value;
      values._changed = true;
      Object.assign(child, values);
      i++;
    }
  }

  addChild(type){
    this.saveFormsToChildren();
    this.children.push({
      _unit_id: 'n' + new Date().getTime(),
      unit_model_unit_type: type,
      status: 1
    });
    this.initChildren();
  }

  deleteChild(index){
    this.saveFormsToChildren();
    if (index > -1) {
      this.children.splice(index, 1);
    }
    this.initChildren();
  }

  isValid(){
    if(!this.unitForm.valid){
      return false;
    }
    for(let index = 0; index < this.children.length; index++){
      let form: FormGroup = this.childForms[index];
      if(!form.valid){
        return false;
      }
    }
    return true;
  }

  showBurnerFields(){
    const unit_type = this.unitForm.get('unit_type').value;
    const fuel_type = this.unitForm.get('fuel_type').value;
    if(unit_type == 'Gasketel met ventilator brander' || fuel_type == 'Stookolie / Mazout'){
      return true;
    }
    return false;
  }

  save(){
    if(!this.saving && this.isValid()){
      this.saving = true;
      this.changeDetector.detectChanges();
      this.saveFormsToChildren();
      let unit = this.unitForm.value;
      unit.list_title = unit.unit_brand + ' ' + unit.unit_model + ' ' + unit.unit_version;
      unit.list_subtitle = unit.passport_nr;
      if(unit.cascade && unit.cascade != 'Nee'){
        if(unit.list_subtitle) unit.list_subtitle += ' - ';
        unit.list_subtitle += 'Cascade toestel: ' + unit.cascade;
      }
      unit.photos = this.photos;
      unit.files = this.files;
      unit.children = this.children;
      unit._changed = true;
      Object.assign(this.unit, unit);
      if(this.unit._selected){
        // Prevent multiple _selected flags
        for(let j = 0; j < this.parent.units.length; j++){
          this.parent.units[j]._selected = false;
        }
        this.unit._selected = true;
        Object.assign(this.parent.data._selected_unit, this.unit);
        Object.assign(this.parent.data._selected_units, [this.unit]);
      }
      setTimeout(() => {
        this.closeModal();
      }, 1000);
    }
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportEditUnitPage');
  }

  ionViewDidEnter() {
    // Translate ion-select fix
    if (this.ionSelects) this.ionSelects.map((select) => select._inputUpdated());
  }

  uploadPhotos() {
    for (let photo of this.photos) {
      if (!photo.file_id) {
        this.apiService.uploadPhoto(photo.src, 'unit').then((data: any) => {
          photo.file_id = data.file_id;
          photo.token = data.token;
          photo.src = data.display_url;
          photo._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

  uploadFiles() {
    for (let file of this.files) {
      if (!file.file_id) {
        this.apiService.uploadFile(file.src, file.filename, 'unit').then((data: any) => {
          file.file_id = data.file_id;
          file.token = data.token;
          file.src = data.display_url;
          file._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-edit-unit/report-edit-unit.ts